// DocSearch initialisation. Brand-aware: reads `data-brand` attribute from
// the dashboard header and picks the corresponding Algolia index.
import docsearch from '@docsearch/js';
// CSS is imported via app/assets/tailwind/application.css

interface BrandConfig {
  appId: string;
  apiKey: string;
  indexName: string;
  askAi: {
    indexName: string;
    appId: string;
    apiKey: string;
    assistantId: string;
  };
}

const IDEAL: BrandConfig = {
  appId: 'J6BSLG6NKJ',
  apiKey: 'ee618502a8ba818327b5c3e9d3b185ab',
  indexName: 'Ideal Postcodes Docsearch Crawler',
  askAi: {
    indexName: 'markdown-index',
    appId: 'J6BSLG6NKJ',
    apiKey: 'ee618502a8ba818327b5c3e9d3b185ab',
    assistantId: '5UNUyT4W1oqW',
  },
};

const ZEN: BrandConfig = {
  appId: '1L1WXE27H7',
  apiKey: 'fbe3a4eda9be784f63cef7bb59d7d64c',
  indexName: 'AddressZen Docs',
  askAi: {
    indexName: 'markdown-index',
    appId: '1L1WXE27H7',
    apiKey: 'fbe3a4eda9be784f63cef7bb59d7d64c',
    assistantId: '92leQYOWaWzZ',
  },
};

export const initDocSearch = (): void => {
  const container = document.getElementById('docsearch');
  if (!container) return;

  const brand = container.closest('[data-brand]')?.getAttribute('data-brand');
  const config = brand === 'zen' ? ZEN : IDEAL;

  docsearch({
    container: '#docsearch',
    appId: config.appId,
    apiKey: config.apiKey,
    indexName: config.indexName,
    askAi: config.askAi,
  });

  // Wire up the dashboard trigger button to open the modal
  const trigger = document.getElementById('docsearch-trigger');
  if (trigger) {
    trigger.addEventListener('click', () => {
      // DocSearch listens for Ctrl+K on window
      window.dispatchEvent(new KeyboardEvent('keydown', {
        key: 'k',
        ctrlKey: true,
        bubbles: true,
        cancelable: true,
      }));
    });
  }
};
